import React from 'react';

function PlayingXIIndex(props){
    return <div>PlayingXI Component</div>
}

export default PlayingXIIndex;